import React from 'react';
import {Layout, Menu, Image, Button, BackTop} from 'antd';
import {Route, Router, Switch, Redirect} from "react-router";
import {createBrowserHistory} from 'history';
import routes from '../router/index';

const {Header, Content, Footer} = Layout;


export default class HomePage extends React.Component {
    constructor(props) {
        super(props);
        let menuList = [];
        for (let route of routes) {
            if (!route.disabled) {
                menuList = [...menuList, {
                    label: route.name, key: route.path
                }];
            }
        }
        this.state = {
            menuList: menuList,
            selectMenu: [],
            history: createBrowserHistory(),
            update: 0,
            height: window.innerHeight - 200,
            upTopMovedStatus: false,
        }
        this.navigationRoute = this.navigationRoute.bind(this)
        this.updatePage.bind(this);
    }

    componentDidMount() {
        window.setSettingCallBack(this);
        window.addEventListener('resize', this.updatePage)
    }

    componentWillUnmount() {
        window.setSettingCallBack(null);
        window.removeEventListener('resize', this.updatePage)
    }

    updatePage = () => {
        this.setState({
            update: this.state.update + 1
        })
    }

    navigationRoute(path) {
        this.setState({
            selectMenu: [path]
        })
        this.state.history.push(path)
        window.scroll(0,0)
    }

    render() {
        return (
            <Layout id={this.state.update} className="invisible-bar">
                <Header className={'flex-row justify-between'} style={{background:'#F5F7FA'}}>
                    <div className={'flex-row flex1'}>
                        <Image src={'images/ic_logo.png'} preview={false} onClick={() => {
                            this.navigationRoute('/index')
                        }}/>
                        <Menu
                            className={'menu-view'}
                            style={{ marginLeft: 100,background:'#F5F7FA'}}
                            theme={'dark'}
                            mode={'horizontal'}
                            inlineCollapsed={false}
                            selectedKeys={this.state.selectMenu}
                            items={this.state.menuList}
                            onSelect={(item) => {
                                this.navigationRoute(item.keyPath[0]);
                            }}
                        >
                        </Menu>
                    </div>
                    <Button type="primary" shape="default" size={'large'} className={'concat-btn'} onClick={() => {
                        this.navigationRoute('/concatUs')
                    }}>Need to contact</Button>
                </Header>
                <Content style={{background: "#fff"}}>
                    <Router history={this.state.history}>
                        <Switch>
                            {
                                routes.map((item, index) => {
                                    return (
                                        <Route key={index} path={item.path}
                                               render={(props) => {
                                                   return <item.component {...props}
                                                                          navigationRoute={this.navigationRoute}></item.component>
                                               }}/>
                                    )
                                })
                            }
                            <Redirect to="/index" from='/'/>
                        </Switch>
                    </Router>
                    <BackTop style={{bottom: 100}}>
                        <img
                            src={this.state.upTopMovedStatus ? 'images/ic_up_top_moved.png' : 'images/ic_up_top_normal.png'}
                            alt={'up'} onMouseOver={() => {
                            this.setState({
                                upTopMovedStatus: true
                            })
                        }}
                            onMouseLeave={() => {
                                this.setState({
                                    upTopMovedStatus: false
                                })
                            }}/>
                    </BackTop>
                </Content>
                <Footer style={{textAlign: 'center'}}>
                    <a href="https://beian.miit.gov.cn/" target={"_blank"}  rel="noreferrer"  className={'color666666'}>沪ICP备2023002141号-1</a>
                </Footer>
            </Layout>
        );
    }
}


